export default () => {
    return window.__INITIAL_DATA__ ? window.__INITIAL_DATA__ : {};
}